import request from "../utils/http"

let baseApi = 'https://ms.lhjing.com/sale-manage'
if (String(window.location.origin).indexOf('test') > -1
  || String(window.location.origin).indexOf('localhost') > -1) {
  baseApi = 'http://10.66.210.12:8004/04-sale-manage'
}

export function externalUser(data) {
  return request({
    url: `${baseApi}/enterprise_wechat/registerUser`,
    method: 'post',
    data
  })
}

export function checkExternalUser(data) {
  return request({
    url: `${baseApi}/enterprise_wechat/checkUser`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/wechatApi.js